<script setup lang="ts">
import { ref, Ref } from 'vue';

import {
  Context,
  Layer as PopupInterface,
} from '@thehotelsnetwork/personalization-types';
import { Popup } from '@thehotelsnetwork/personalization-core';

type ToolPayload = {
  tool: PopupInterface;
  context: Context;
}

type ContainerMapData = {
  tools: ToolPayload[];
  visible: boolean;
}

const containerMap: Ref<ContainerMapData> = ref({
  tools: [],
  visible: false,
});

// This function removes a popup element from its container. if there is no position assigned
// we assume this is a FullScreen Popup
function removePopup(popup: PopupInterface) {
  setTimeout(() => {
    containerMap.value.tools = containerMap.value.tools
      .filter(payload => payload.tool.id !== popup.id);
  }, 500);
}

// Add popup element function
function addPopup(popupPayload: { tool: PopupInterface, context: Context }) {
  const { tool } = popupPayload;

  // Show container in case it's not visible yet
  if (!containerMap.value.visible) {
    containerMap.value.visible = true;
  }
  containerMap.value.tools.push(popupPayload);

  return removePopup.bind(null, tool);
}

defineExpose({
  addPopup,
  removePopup,
});

</script>

<template>
  <div
    class="container"
    data-testid="main-container"
    v-if="containerMap.tools.length"
  >
    <Popup
      v-for="popupProps in containerMap.tools"
      :key="popupProps.tool.id"
      v-bind="popupProps"
      @hidden="removePopup(popupProps.tool)"
    />
  </div>
</template>

<style lang="postcss">
.container {
  position: fixed;
  width: 100%;
  height: 100dvh;
  pointer-events: none;
  .thn--tool {
    blockquote, dd, dl, figure, h1, h2, h3, h4, h5, h6, hr, p, pre {
      margin: 0;
    }
    div[class*="__popup"],
    div[class*="__overlay"],
    button[class*="__tab"],
    button[class*="-xclose"]{
      pointer-events: auto;
    }
  }
}
</style>
